import store from '@/store';
import poiElements from '@data/poiElements';

let poiConfigCompleted = false;

export function getPoiConfig(value, extendWithDynamic = true) {
    if (!poiConfigCompleted) {
        completePoiConfig();
    }

    let config = poiElements.find((poi) => poi.value === value);
    if(extendWithDynamic) config = extendPoiConfigWithDynamicData(value, config)
    if (!config) return false;
    return config;
}

function completePoiConfig() {
    poiElements.forEach((poiElement) => {
        if (poiElement.categories) {
            poiElement.categories.forEach((category) => {
                const format = category.format ?? 'svg';
                category.image = `${process.env.BASE_URL}/images/poi-icons/${poiElement.value}/full/${category.imageName}.${format}`;
                category.symbol = `${process.env.BASE_URL}/images/poi-icons/${poiElement.value}/symbol/${category.imageName}.${format}`;

                if (category.children) {
                    category.children.forEach((childCategory) => {
                        const childFormat = childCategory.format ?? 'svg'
                        childCategory.image = `${process.env.BASE_URL}/images/poi-icons/${poiElement.value}/full/${childCategory.imageName}.${childFormat}`;
                        childCategory.symbol = `${process.env.BASE_URL}/images/poi-icons/${poiElement.value}/symbol/${childCategory.imageName}.${childFormat}`;
                    });
                }
            });
        } else if (poiElement.imageName) {
            const format = poiElement.format ?? 'svg';
            poiElement.image = `${process.env.BASE_URL}/images/poi-icons/${poiElement.value}/full/${poiElement.imageName}.${format}`;
            poiElement.symbol = `${process.env.BASE_URL}/images/poi-icons/${poiElement.value}/symbol/${poiElement.imageName}.${format}`;
        }        
    });
    completeFavouritesConfig()
    poiConfigCompleted = true;
}

function extendPoiConfigWithDynamicData(type, config) {
    if(store.getters.dynamicPoiElements[type]) {
        return {...config, ...store.getters.dynamicPoiElements[type]}
    }
    return config
}

function completeFavouritesConfig() {
    // add all poi categories to favourites categories
    const favouritesElement = poiElements.find(element => element.value === 'favourites')
    poiElements.forEach(poiElement => {
        if(poiElement.value !== 'favourites') {
            if (poiElement.categories) {
                favouritesElement.categories = [...favouritesElement.categories, ...poiElement.categories]
            } else {
                favouritesElement.categories.push(poiElement)
            }
        }
    })
}